// @flow

import * as React from 'react';
import DefaultSelect from 'react-select';

type Props = {
  className?: string
}

const Select = ({ className, ...rest }: Props) => (
  <DefaultSelect className={className} classNamePrefix="select" {...rest} />
);

Select.defaultProps = {
  className: 'select-wrap'
};

export default Select;
